/**
 *  @class
 *  @function CartProgress
 */

if (!customElements.get('cart-progress')) {
  class CartProgress extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      let total = parseInt(this.dataset.cartTotal, 10);
      let freeShippingMinimum = Math.round(
        parseInt(this.dataset.freeShippingMinimum || 0, 10) * (Shopify.currency.rate || 1)
      );
      let freeGiftMinimum = Math.round(
        parseInt(this.dataset.freeGiftMinimum || 0, 10) * (Shopify.currency.rate || 1)
      );
      let secondFreeGiftMinimum = Math.round(
        parseInt(this.dataset.secondFreeGiftMinimum || 0, 10) * (Shopify.currency.rate || 1)
      );

      // maximum threshold over all three levels
      let minimum = Math.max(freeShippingMinimum, freeGiftMinimum, secondFreeGiftMinimum);
      let percentage = 1;

      this.shippingRemainingText = this.querySelector('.cart-progress--text-shipping-remaining');
      this.shippingFullText = this.querySelector('.cart-progress--text-shipping-full');
      this.giftRemainingText = this.querySelector('.cart-progress--text-gift-remaining');
      this.giftFullText = this.querySelector('.cart-progress--text-gift-full');

      const firstGiftText = this.querySelector('.cart-progress--text-gift-remaining .first-gift');
      const secondGiftText = this.querySelector('.cart-progress--text-gift-remaining .second-gift');

      // progress bar percentage
      if (total < minimum) {
        percentage = total / minimum;
      }

      // Shipping text
      if (this.shippingRemainingText && this.shippingFullText) {
        if (total < freeShippingMinimum) {
          this.shippingRemainingText.style.display = 'block';
          this.shippingFullText.style.display = 'none';
        } else {
          this.shippingRemainingText.style.display = 'none';
          this.shippingFullText.style.display = 'block';
        }
      }

      // Gift text (handles first and optional second gift)
      if (freeGiftMinimum > 0 && this.giftRemainingText && this.giftFullText) {
        if (total < freeGiftMinimum) {
          // before first gift
          this.giftRemainingText.style.display = 'block';
          if (firstGiftText) firstGiftText.style.display = 'block';
          if (secondGiftText) secondGiftText.style.display = 'none';
          this.giftFullText.style.display = 'none';
        } else if (secondFreeGiftMinimum > 0 && total < secondFreeGiftMinimum) {
          // between first and second gift
          this.giftRemainingText.style.display = 'block';
          if (firstGiftText) firstGiftText.style.display = 'none';
          if (secondGiftText) secondGiftText.style.display = 'block';
          this.giftFullText.style.display = 'none';
        } else {
          // all gifts unlocked (or no second gift configured)
          this.giftRemainingText.style.display = 'none';
          if (firstGiftText) firstGiftText.style.display = 'none';
          if (secondGiftText) secondGiftText.style.display = 'none';
          this.giftFullText.style.display = 'block';
        }
      }

      this.style.setProperty('--percentage', percentage);

      // Markers + labels
      let format = window.theme.settings.money_with_currency_format || '${{amount}}';

      if (minimum > 0) {
        // SHIPPING MARKER
        if (freeShippingMinimum > 0) {
          let shippingPosition = (freeShippingMinimum / minimum) * 100;
          this.style.setProperty('--shipping-position', shippingPosition + '%');

          let shippingLabel = this.querySelector(
            '.cart-progress--marker-wrapper-shipping .cart-progress--marker-label'
          );
          if (shippingLabel) {
            let formattedPrice = formatMoney(freeShippingMinimum, format);
            shippingLabel.textContent = formattedPrice.replace(/[.,]\d+/, '');
          }

          let shippingMarker = this.querySelector(
            '.cart-progress--marker-wrapper-shipping .cart-progress--marker'
          );
          if (shippingMarker) {
            if (total >= freeShippingMinimum) {
              shippingMarker.classList.add('cart-progress--marker-reached');
            } else {
              shippingMarker.classList.remove('cart-progress--marker-reached');
            }
          }
        }

        // FIRST GIFT MARKER
        if (freeGiftMinimum > 0) {
          let giftPosition = (freeGiftMinimum / minimum) * 100;
          this.style.setProperty('--gift-position', giftPosition + '%');

          let giftLabel = this.querySelector(
            '.cart-progress--marker-wrapper-gift .cart-progress--marker-label'
          );
          if (giftLabel) {
            let formattedPrice = formatMoney(freeGiftMinimum, format);
            giftLabel.textContent = formattedPrice.replace(/[.,]\d+/, '');
          }

          let giftMarker = this.querySelector(
            '.cart-progress--marker-wrapper-gift .cart-progress--marker'
          );
          if (giftMarker) {
            if (total >= freeGiftMinimum) {
              giftMarker.classList.add('cart-progress--marker-reached');
            } else {
              giftMarker.classList.remove('cart-progress--marker-reached');
            }
          }
        }

        // SECOND GIFT MARKER
        if (secondFreeGiftMinimum > 0) {
          let secondGiftPosition = (secondFreeGiftMinimum / minimum) * 100;
          this.style.setProperty('--second-gift-position', secondGiftPosition + '%');

          let secondGiftLabel = this.querySelector(
            '.cart-progress--marker-wrapper-second-gift .cart-progress--marker-label'
          );
          if (secondGiftLabel) {
            let formattedPrice = formatMoney(secondFreeGiftMinimum, format);
            secondGiftLabel.textContent = formattedPrice.replace(/[.,]\d+/, '');
          }

          let secondGiftMarker = this.querySelector(
            '.cart-progress--marker-wrapper-second-gift .cart-progress--marker'
          );
          if (secondGiftMarker) {
            if (total >= secondFreeGiftMinimum) {
              secondGiftMarker.classList.add('cart-progress--marker-reached');
            } else {
              secondGiftMarker.classList.remove('cart-progress--marker-reached');
            }
          }
        }
      }
    }
  }

  customElements.define('cart-progress', CartProgress);
}
